subscribe(PUB_SUB_EVENTS.mapsApiLoad, () => {
  if (!customElements.get('store-locator')) {
    class StoreLocator extends HTMLElement {
      selectors = {
        dataMapStyles: 'data-map-styles',
        urlParam: 'data-param',
        totalPages: 'data-pages',
        dataMapDefaultLat: 'data-map-default-lat',
        dataMapDefaultLng: 'data-map-default-lng',
        dataMapZoomDefault: 'data-map-zoom-default',
        dataMapZoomNoRes: 'data-map-zoom-no-res',
        dataMapZoomGeolocated: 'data-map-zoom-geolocated',
        dataMapZoomLocality: 'data-map-zoom-locality',
        mapFilter: '[map-filter]',
        mapResults: '.store-map__results',
        mapSearch: '[map-search]',
        mapSearchGeolocation: '[map-search-geolocation]',
        mapSearchForm: '[map-search-form]',
        mapStoreBackToList: '[map-store-back-to-list]',
        mapStoreItem: '#map-template-item',
        mapStoresList: '[map-stores-list]',
        mapTemplateItem: '[map-store-item]',
        mapDiv: 'g-map',
      };
      breakpointLg = 990;

      constructor() {
        super();
        this.mapDiv = this.querySelector(this.selectors.mapDiv);
        this.mapStyles = this.getAttribute(this.selectors.dataMapStyles) && JSON.parse(this.getAttribute(this.selectors.dataMapStyles));
        this.storeUrlParam = this.getAttribute(this.selectors.urlParam);
        this.storeTotalPages = this.getAttribute(this.selectors.totalPages);
        this.userPosition = new UserPosition();
        this.defaultLat = parseFloat(this.getAttribute(this.selectors.dataMapDefaultLat)) || '';
        this.defaultLng = parseFloat(this.getAttribute(this.selectors.dataMapDefaultLng)) || '';
        this.zoomDefault = parseInt(this.getAttribute(this.selectors.dataMapZoomDefault)) || '';
        this.zoomNoRes = parseInt(this.getAttribute(this.selectors.dataMapZoomNoRes)) || '';
        this.zoomGeolocated = parseInt(this.getAttribute(this.selectors.dataMapZoomGeolocated)) || '';
        this.zoomLocality = parseInt(this.getAttribute(this.selectors.dataMapZoomLocality)) || '';
      }
      async connectedCallback() {
        this.day = this.getDayOfTheWeek();
        this.allFiltersActives = this.querySelectorAll(this.selectors.mapFilter);
        this.mapStores = sessionStorage.getItem('storeObj') && sessionStorage.getItem('storeObjIsoCode') === window.Shopify.locale ? JSON.parse(sessionStorage.getItem('storeObj')) : null;
        this.searchGeolocationBtn = this.querySelector(this.selectors.mapSearchGeolocation);
        this.searchInput = this.querySelector(this.selectors.mapSearch);
        this.searchForm = this.querySelector(this.selectors.mapSearchForm);
        this.storeItemTemplate = this.querySelector(this.selectors.mapStoreItem).content.querySelector(this.selectors.mapTemplateItem).innerHTML;
        this.storesList = this.querySelector(this.selectors.mapStoresList);
        this.mapResults = this.querySelector(this.selectors.mapResults);
        this.setSearchInterfaceHeight();
        window.matchMedia(`(max-width: ${this.breakpointLg}px)`).addEventListener('change', this.setSearchInterfaceHeight.bind(this));

        this.mapStores != null ? this.init() : this.fetchStores();
      }

      /**
       * Initialize store locator
       *
       * @return  {Void}
       */
      async init() {
        this.initMap();
        await this.setUserCoordinates(true);
        this.initSearchAutocomplete();
        this.initFilters();
      }

      /**
       * Set height of search block needed for mobile version
       *
       * @return  {Void}
       */
      setSearchInterfaceHeight() {
        document.documentElement.style.setProperty('--search-interface-height', `${this.searchForm.offsetHeight}px`);
        if (window.matchMedia(`(max-width: ${this.breakpointLg}px)`)) {
          document.documentElement.style.setProperty('--searchResult-interface-height', `${this.mapResults.offsetHeight}px`);
        }
      }

      /**
       * fetch stores object and init map
       *
       * @return  {Void}
       */
      fetchStores() {
        const stores = [];
        const promise = [];
        for (let i = 1; i <= this.storeTotalPages; i++) {
          promise.push(
            new Promise((resolve, reject) => {
              fetch(`${window.location.pathname}?page=${i}&${this.storeUrlParam}=${i}&view=stores-list`)
                .then((response) => response.json())
                .then((data) => {
                  const responseObject = data.stores;
                  stores.push(...responseObject);
                  resolve();
                })
                .catch((error) => {
                  reject(error);
                });
            })
          );
        }
        Promise.all(promise).then(() => {
          sessionStorage.setItem('storeObj', JSON.stringify(stores));
          sessionStorage.setItem('storeObjIsoCode', window.Shopify.locale);
          this.mapStores = stores;
          this.init();
        });
      }

      /**
       * Init map, populate map
       * and get filtered pharmacy when
       * map is in idle state
       *
       * @return  {Void}
       */
      initMap() {
        if (!this.map) {
          this.map = new google.maps.Map(this.mapDiv, {
            center: new google.maps.LatLng(this.defaultLat, this.defaultLng),
            zoom: 7,
            disableDefaultUI: true,
            zoomControl: true,
            zoomControlOptions: {
              position: google.maps.ControlPosition.RIGHT_BOTTOM,
            },
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            gestureHandling: 'cooperative',
            styles: this.mapStyles,
          });

          this.populateMap();

          // Event to handle sidebar updates
          google.maps.event.addListener(this.map, 'idle', () => {
            this.showResults();
          });
          google.maps.event.addListener(this.map, 'dragend', () => {
            this.searchInput.value = '';
            this.searchGeolocationBtn.setAttribute('data-reset', 0);
          });
        } else {
          this.map.setCenter(new google.maps.LatLng(this.defaultLat, this.defaultLng));
        }
      }

      /**
       * get all stores
       * set markers and init markerClusters
       *
       * @return  {Void}
       */
      populateMap() {
        if (this.mapStores === null) return;

        this.setMapBoundsPadding();

        this.map.panBy(this.boundsPadding.top);

        this.stores = [];

        this.mapStores.forEach((store) => {
          let storeObject = new Store(store);
          storeObject.marker = this.setMarker(storeObject.lat, storeObject.lng, storeObject.name, window.storeLocatorStrings.pins[storeObject.type]);
          this.initMarkerEvents(storeObject);
          this.stores.push(storeObject);
        });

        this.createMarkersClusters(this.stores);
      }

      /**
       * set stores visibility,
       * then show results in map
       * @param {Array} allFilters
       *
       * @return {Void}
       */
      filterMap(allFilters) {
        const filteredStores = this.stores.filter((store) => {
          const isVisible = store.setStoreVisibility(allFilters);
          return isVisible;
        });
        this.resetHighlightedMarkers();
        this.mapResults.classList.remove('open');

        this.markersClusters.clearMarkers();
        this.createMarkersClusters(filteredStores);

        filteredStores.length > 0 ? this.adjustMapToMarkers(filteredStores) : this.setMapZoom('noresult');

        this.showResults();
      }

      /**
       * get day of the week,
       *
       * @return {Void}
       */
      getDayOfTheWeek() {
        const today = new Date();
        const day = today.getDay();
        return day - 1;
      }

      /**
       * get stores in view and create stores boxes
       *
       * @return  {Void}
       */
      showResults() {
        const mapBounds = this.getPaddedBounds(this.map, this.boundsPadding.top, this.boundsPadding.bottom, this.boundsPadding.right, this.boundsPadding.left);

        if (mapBounds == null) return;

        const mapCenter = this.map.getCenter();
        this.storesListHtml = '';
        this.storesResults = [];

        this.storesResults = this.stores
          .filter((store) => {
            if (mapBounds.contains({ lat: store.lat, lng: store.lng }) && store.visible) {
              if (!store.marker.getVisible()) store.marker.setVisible(true);
              store.setDistance(mapCenter);
              return true;
            }
          })
          .sort((a, b) => a.distanceFromCenter - b.distanceFromCenter); // distance sort

        if (!this.storesResults.length) {
          this.storesListHtml = `<span class="no_results theme_body">${window.storeLocatorStrings.noResults}</span>`;
        } else {
          this.storesResults.forEach((store) => {
            this.storesListHtml += this.addStoreItem(store);
            this.storesList.scrollTop = 0;
          });
        }

        this.storesList.innerHTML = this.storesListHtml;
      }

      /**
       * manipulate store Item string
       * and populate it with the values of the store
       * @param {Store} store
       *
       * @return {String}
       */
      addStoreItem(store) {
        let storeHtml = this.storeItemTemplate;
        storeHtml = storeHtml.replace('##TYPE##', window.storeLocatorStrings.storeTypes[store.type]);
        storeHtml = storeHtml.replace('##NAME##', store.name);
        storeHtml = storeHtml.replace('##ID##', store.id);
        storeHtml = storeHtml.replace('##ADDRESS##', store.address);
        storeHtml = storeHtml.replace('##OPENING_HOURS##', store.openingHours[this.day] || '');
        storeHtml = !store.ctaLink ? storeHtml.replace('##CTA_CLASS##', 'hidden') : storeHtml.replace('##CTA_URL##', `${store.ctaLink}`).replace('##CTA_CLASS##', '');
        storeHtml = storeHtml.replace('##STORE_URL##', store.storeLink);
        storeHtml = storeHtml.replace('##BRANDS##', store.brands.join('&#20;&#20;&#20;'));

        return storeHtml;
      }

      /**
       * Initialize Search autocomplete input
       *
       * @return  {Void}
       */
      initSearchAutocomplete() {
        const searchInput = this.querySelector(this.selectors.mapSearch);

        this.autocomplete = new google.maps.places.Autocomplete(searchInput, { types: ['geocode'] });
        this.initAutoCompleteEvent(searchInput);
        this.initFindMyPositionEvent(searchInput);
      }

      /**
       * Add listener when place change and
       * set place coordinates
       * @param {Element} searchInput
       *
       * @return  {Void}
       */
      initAutoCompleteEvent(searchInput) {
        google.maps.event.addListener(this.autocomplete, 'place_changed', async () => {
          const place = this.autocomplete.getPlace();
          const address = searchInput.value;
          let originLocation = null;
          let zoomType = 'default';
          if (!place.geometry) {
            await new Promise((resolve, reject) => {
              const geocoder = new google.maps.Geocoder();
              geocoder.geocode({ address: address }, (results, status) => {
                if (status == 'OK') {
                  const lat = results[0].geometry.location.lat();
                  const lng = results[0].geometry.location.lng();
                  originLocation = new google.maps.LatLng(lat, lng);
                  zoomType = results[0].types[0];
                  resolve();
                } else reject(error);
              });
            }).catch((error) => console.debug(error));
          } else {
            originLocation = place.geometry.location;
            zoomType = place.types[0];
          }
          this.setMapCenter(originLocation, zoomType);
        });
      }

      /**
       * Initialize geo localization position button
       *
       * @return  {Void}
       */
      initFindMyPositionEvent(searchInput) {
        this.searchGeolocationBtn.addEventListener('click', (event) => {
          const btn = event.currentTarget;
          if (btn.getAttribute('data-reset') == 1) {
            btn.setAttribute('data-reset', 0);
            searchInput.value = '';
            this.setMapCenter(null, 'nolocation');
          } else {
            this.setUserCoordinates(true);
          }
        });
      }

      /**
       * initialize filter 'change' event and filter map
       *
       * @return {Void}
       */
      initFilters() {
        if (!this.allFiltersActives) return;

        this.allFiltersActives.forEach((filter) => {
          filter.addEventListener('filterChange', () => {
            const allFilters = [...this.allFiltersActives].map((filter) => {
              return { value: filter.value, key: filter.dataset.key };
            });
            this.filterMap(allFilters);
          });
        });

        this.getParamsFilters();
      }

      /**
       * get filter params from url and set filters
       *
       * @return {Void}
       */
      getParamsFilters() {
        const queryString = new URL(window.location);
        const urlParams = new URLSearchParams(queryString.search);
        let paramsFilters = [];

        urlParams.forEach((value, key) => {
          const decodedValue = decodeURIComponent(value);
          const decodedKey = decodeURIComponent(key);
          paramsFilters = [...paramsFilters, { value: decodedValue, key: decodedKey }];
        });

        paramsFilters.forEach((filter) => {
          const filterDisclosure = this.querySelector(`filter-disclosure[data-filter="${filter.key}"]`);
          if (!filterDisclosure) return;

          const filterElement = filterDisclosure.querySelector(`a[data-value="${filter.value}"]`);
          if (filterElement) filterElement.click();
        });
      }

      /**
       * initialize marker clusters
       * @param {Array} stores
       *
       * @return {Void}
       */
      createMarkersClusters(stores) {
        const mcOptions = {
          gridSize: 50,
          maxZoom: 15,
          styles: [
            {
              url: window.storeLocatorStrings.clusterIcon,
              height: 33,
              width: 33,
              anchor: [0, 0],
              textColor: '#F7F7F7',
              textSize: 11,
            },
          ],
        };

        this.markersClusters = new MarkerClusterer(
          this.map,
          stores.map((store) => store.marker),
          mcOptions
        );
      }

      /**
       * Set paddings in map based on absolute elements
       *
       * @return {Void}
       */
      setMapBoundsPadding() {
        const headerHeight = window.innerWidth > this.breakpointLg ? document.querySelector('.header').offsetHeight : 0;
        this.boundsPadding = {
          top: headerHeight,
          right: 0,
          bottom: 0,
          left: 0,
        };
      }

      /**
       * move to the first visible marker
       * when filtering and there are
       * no visible markers in view
       * @param {Array} stores
       *
       * @return {Void}
       */
      adjustMapToMarkers(stores) {
        const mapBounds = this.getPaddedBounds(this.map, this.boundsPadding.top, this.boundsPadding.bottom, this.boundsPadding.right, this.boundsPadding.left),
          mapCenter = this.map.getCenter();

        if (!mapBounds) return;

        let hasStores = false;

        stores = stores
          .map((store) => {
            store.setDistance(mapCenter);
            return store;
          })
          .sort((a, b) => a.distanceFromCenter - b.distanceFromCenter);

        stores.some((store) => {
          const markerPosition = store.marker.getPosition();
          if (!mapBounds.contains(markerPosition)) {
            if (!hasStores) {
              mapBounds.extend(markerPosition);
            }
            return true;
          } else {
            hasStores = true;
            return false;
          }
        });

        this.map.fitBounds(mapBounds, this.boundsPadding);
      }

      /**
       * retrieve coordinates of bounds of the map
       * @param {Object} map
       * @param {Number} npad
       * @param {Number} spad
       * @param {Number} epad
       * @param {Number} wpad
       *
       * @return {Object}
       */
      getPaddedBounds(map, npad, spad, epad, wpad) {
        const mapBounds = map.getBounds();
        if (!mapBounds) return null;

        const SW = mapBounds.getSouthWest();
        const NE = mapBounds.getNorthEast();
        let topRight = map.getProjection().fromLatLngToPoint(NE);
        let bottomLeft = map.getProjection().fromLatLngToPoint(SW);
        let scale = Math.pow(2, map.getZoom());

        let SWtopoint = map.getProjection().fromLatLngToPoint(SW);
        let SWpoint = new google.maps.Point((SWtopoint.x - bottomLeft.x) * scale + wpad, (SWtopoint.y - topRight.y) * scale - spad);
        let SWworld = new google.maps.Point(SWpoint.x / scale + bottomLeft.x, SWpoint.y / scale + topRight.y);
        const pt1 = map.getProjection().fromPointToLatLng(SWworld);

        let NEtopoint = map.getProjection().fromLatLngToPoint(NE);
        let NEpoint = new google.maps.Point((NEtopoint.x - bottomLeft.x) * scale - epad, (NEtopoint.y - topRight.y) * scale + npad);
        let NEworld = new google.maps.Point(NEpoint.x / scale + bottomLeft.x, NEpoint.y / scale + topRight.y);
        const pt2 = map.getProjection().fromPointToLatLng(NEworld);

        return new google.maps.LatLngBounds(pt1, pt2);
      }

      /**
       * Set initial coordinates:
       * get user position coordinates,
       * set it in map and show address in search input
       * @param {Boolean} setMapCenter
       *
       * @return {Void}
       */
      async setUserCoordinates(setMapCenter) {
        if (this.userPosition.isUserLocEmpty()) {
          await this.userPosition.getGeoPosition();
        }
        this.userPosition.setAddressInSearch(this.searchInput);
        this.searchGeolocationBtn.setAttribute('data-reset', 1);

        if (setMapCenter) {
          this.setMapCenter(new google.maps.LatLng(this.userPosition.lat, this.userPosition.lng), this.userPosition.addressType ? 'geolocated' : 'default');
        }
      }

      /**
       * set center of map and zoom
       * @param  {Object} coordinates
       * @param  {Number} zoom
       *
       * @return {Void}
       */
      setMapCenter(coordinates, zoom) {
        this.map.setCenter(coordinates ? coordinates : new google.maps.LatLng(this.defaultLat, this.defaultLng));
        if (zoom) this.setMapZoom(zoom);
      }

      /**
       * set zoom on map based on given string
       * @param {Number} zoomType
       *
       * @return {Void}
       */
      setMapZoom(zoomType) {
        // Adjust zoom depending on locality search
        switch (zoomType) {
          case 'administrative_area_level_1':
          case 'administrative_area_level_2':
          case 'administrative_area_level_3':
            this.map.setZoom(10);
            break;

          case 'locality':
          case 'neighborhood':
            this.map.setZoom(this.zoomLocality);
            break;

          case 'route':
          case 'street_address':
            this.map.setZoom(15);
            break;

          case 'nolocation':
          case 'nolocation_block':
          case 'noresult':
            this.map.setZoom(this.zoomNoRes);
            break;

          case 'geolocated':
            this.map.setZoom(this.zoomGeolocated);
            break;

          case 'default':
          default:
            this.map.setZoom(this.zoomDefault);
            break;
        }
      }

      /**
       * set marker in map
       * @param {Number}  lat
       * @param {Number}  lng
       * @param {String}  title
       * @param {String}  icon
       *
       * @return  {Object}
       */
      setMarker(lat, lng, title, icon) {
        return new google.maps.Marker({
          position: { lat, lng },
          map: this.map,
          title: title,
          animation: google.maps.Animation.DROP,
          icon: {
            url: icon,
            scaledSize: new google.maps.Size(40, 50),
          },
        });
      }

      /**
       * reset all highlighted markers in map
       *
       * @return  {Void}
       */
      resetHighlightedMarkers() {
        const animatedMarker = this.stores.find((store) => store.marker.getAnimation() !== null);
        if (!animatedMarker) return;
        animatedMarker.marker.setAnimation(null);
        const mapResult = this.mapResults.querySelector(`[data-id="${animatedMarker.id}"]`);
        if (mapResult) mapResult.classList.remove('highlighted');
      }

      /**
       * set marker events: click opens infoWindow on mobile
       * highlight marker and zoom map
       * @param {Store} store
       *
       * @return {Void}
       */
      initMarkerEvents(store) {
        store.marker.addListener('click', (event) => {
          if (store.marker.getAnimation() !== null) {
            store.marker.setAnimation(null);
            this.mapResults.querySelector(`[data-id="${store.id}"]`).classList.remove('highlighted');
            return;
          }
          this.resetHighlightedMarkers();
          const currentMapZoom = this.map.getZoom();
          const zoomType = currentMapZoom < this.zoomLocality ? 'locality' : null;
          this.setMapCenter(new google.maps.LatLng(store.lat, store.lng), zoomType);
          setTimeout(this.scrollToStore.bind(this, store), 50);
          this.toggleBounce(store);
        });
      }

      /**
       * scroll to selected store in map results
       *
       * @param {Store} store
       *
       * @return {Void}
       */
      scrollToStore(store) {
        const selectedStore = this.mapResults.querySelector(`[data-id="${store.id}"]`);
        if (this.breakpointLg > window.innerWidth) {
          const firstInnerDiv = this.mapDiv.querySelector('div');
          if (typeof lenis !== 'undefined') {
            lenis.scrollTo(firstInnerDiv);
          } else {
            firstInnerDiv.scrollIntoView({ behavior: 'smooth' });
          }
        }
        this.storesList.scrollTop = selectedStore.offsetTop;
        selectedStore.classList.add('highlighted');
      }

      toggleBounce(store) {
        if (store.marker.getAnimation() !== null) {
          store.marker.setAnimation(null);
        } else {
          store.marker.setAnimation(google.maps.Animation.BOUNCE);
        }
      }
    }

    customElements.define('store-locator', StoreLocator);
  }

  if (!customElements.get('filter-disclosure')) {
    class FilterDisclosure extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="filter-input"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          items: this.querySelectorAll('a'),
          selectedItem: this.querySelector('span.disclosure__selected-item'),
        };
        this.defaultContent = this.elements.selectedItem.textContent;
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.customEvent = new CustomEvent('filterChange');
        this.elements.items.forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        this.isClosedByFocusOut = false;
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        setTimeout(() => {
          this.closedByFocusOut = false;
        }, 200);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      openSelector() {
        if (this.closedByFocusOut) return;
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
      }

      closeSelector(event) {
        const isChild = this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.closedByFocusOut = true;
          this.hidePanel();
        }
      }

      selectItem(currentTarget) {
        this.elements.input.value = currentTarget.dataset.value;
        this.elements.items.forEach((item) => {
          item.classList.remove('disclosure__link--active');
          item.setAttribute('aria-current', 'false');
        });
        currentTarget.classList.add('disclosure__link--active');
        currentTarget.setAttribute('aria-current', 'true');
        this.elements.selectedItem.textContent = currentTarget.textContent;
        this.elements.input.dispatchEvent(this.customEvent);
      }

      deselectItem() {
        this.elements.input.value = 'All';
        this.elements.items.forEach((item) => {
          item.classList.remove('disclosure__link--active');
          item.setAttribute('aria-current', 'false');
        });
        this.elements.selectedItem.textContent = this.defaultContent;
        this.elements.input.dispatchEvent(this.customEvent);
      }

      onItemClick(event) {
        event.preventDefault();
        this.elements.input.value === event.currentTarget.dataset.value ? this.deselectItem() : this.selectItem(event.currentTarget);
        this.hidePanel();
      }
    }
    customElements.define('filter-disclosure', FilterDisclosure);
  }
});

class UserPosition {
  lat;
  lng;
  address;
  addressType;
  constructor() {
    this.#getStoredPosition();
  }
  #getStoredPosition() {
    const savedPosition = JSON.parse(sessionStorage.getItem('storelocator_user_pos'));
    if (savedPosition == null) return;

    this.address = savedPosition.address;
    this.addressType = savedPosition.addressType;
    this.lat = savedPosition.lat;
    this.lng = savedPosition.lng;
  }

  /**
   * Check if we have user location
   *
   * @return  {Void}
   */
  isUserLocEmpty() {
    return this.lat == null && this.lng == null && this.address == null;
  }

  /**
   * Set address on input search
   *
   * @return  {Void}
   */
  setAddressInSearch(searchInput) {
    if (this.address != null) {
      searchInput.value = this.address;
    }
  }

  /**
   * Get browser location position and set user coordinates
   *
   * @return  {Void}
   */
  async getGeoPosition() {
    const geoOptions = {
      enableHighAccuracy: true,
      timeout: 6000, // time in millis when error callback will be invoked
      maximumAge: 0, // max cached age of gps data, also in millis
    };
    await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          if (pos.coords.latitude != 0 && pos.coords.longitude != 0) {
            this.lat = pos.coords.latitude;
            this.lng = pos.coords.longitude;
            const geoResult = await this.#getGeoAddress();
            this.address = geoResult.formatted_address;
            this.addressType = geoResult.types[0];
            this.#saveUserPosition();
          }
          resolve(pos);
        },
        (err) => {
          reject(err);
        },
        geoOptions
      );
    }).catch((error) => console.debug(error));
  }

  /**
   * get user address
   *
   * @return  {Promise}
   */
  async #getGeoAddress() {
    return await new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat: this.lat, lng: this.lng }, region: 'it', country: 'IT' }, (results, status) => {
        status === 'OK' && results[0] ? resolve(results[0]) : reject(new Error(status));
      });
    }).catch((error) => console.warn(error));
  }

  /**
   * save user position in local storage
   *
   * @return  {Void}
   */
  #saveUserPosition() {
    const userPos = {
      address: this.address,
      addressType: this.addressType,
      lat: this.lat,
      lng: this.lng,
    };
    sessionStorage.setItem('storelocator_user_pos', JSON.stringify(userPos));
  }
}

class Store {
  marker;
  markerHighlighted;
  visible = true;
  constructor(store) {
    this.id = store.id;
    this.name = store.name;
    this.address = store.address;
    this.brands = store.brands;
    this.openingHours = store.opening_hours;
    this.lat = parseFloat(store.latitude);
    this.lng = parseFloat(store.longitude);
    this.type = store.type;
    this.ctaLink = store.cta_url;
    this.storeLink = store.store_url;
  }
  /**
   * set distance from center of map
   * @param {Object} mapCenter
   *
   * @return {Void}
   */
  setDistance(mapCenter) {
    this.distanceFromCenter = this.#getDistanceFromLatLonInKm(mapCenter.lat(), mapCenter.lng(), this.lat, this.lng);
  }

  /**
   * calculate distance from center of the map in km
   * @param {Number} lat1
   * @param {Number} lon1
   * @param {Number} lat2
   * @param {Number} lon2
   *
   * @return {Number}
   */
  #getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const deg2rad = (deg) => deg * (Math.PI / 180),
      R = 6371; // Radius of the earth in km
    let dLat = deg2rad(lat2 - lat1), // deg2rad below
      dLon = deg2rad(lon2 - lon1),
      a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km;
  }

  /**
   * check if store marker has to be shown in map
   * @param {Array} allFilters
   *
   * @return  {Boolean}
   */
  setStoreVisibility(allFilters) {
    const allResults = [];
    allFilters.forEach((filter) => {
      let visibility;
      if (filter.value != 'All') {
        if (typeof this[filter.key] === 'string') {
          visibility = this[filter.key] === filter.value;
        } else {
          visibility = this[filter.key].includes(filter.value);
        }
      } else {
        visibility = true;
      }
      allResults.push(visibility);
    });
    this.visible = !allResults.includes(false);
    return !allResults.includes(false);
  }
}
